(() => {
  if (window.DMR_PRODUCT_MEDIA_READY) return;
  window.DMR_PRODUCT_MEDIA_READY = true;
  const states = new WeakMap();
  let optionsQueued = false;
  function hideRetiredFinish() {
    optionsQueued = false;
    document.querySelectorAll('.dmr-product-native .gpo-app input[type="radio"], .dmr-product-native .gpo-app input[type="checkbox"]').forEach(input => {
      if (!/^diamond$/i.test(input.value.trim())) return;
      const wrapper = input.closest('.gpo-swatches, .gpo-radio, .gpo-checkbox');
      if (!wrapper || wrapper.dataset.dmrRetired === 'true') return;
      wrapper.dataset.dmrRetired = 'true';
      wrapper.hidden = true;
      const wasChecked = input.checked;
      input.checked = false;
      input.disabled = true;
      if (wasChecked) input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  const escapeHtml = value => String(value).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
  const THICKNESS_TEXT = {
    standard: 'L’épaisseur standard de nos kits.',
    premium: 'Plus épais et plus rigide, donc plus simple à poser.',
    badge: 'Conseillé · Pose facile',
    included: 'Inclus'
  };
  function enhanceThickness() {
    document.querySelectorAll('.dmr-product-native .gpo-app input[type="radio"][name*="paisseur" i]').forEach(input => {
      const item = input.closest('.gpo-swatches');
      const label = item && item.querySelector('label');
      if (!item || !label || item.dataset.dmrThick) return;
      const value = input.value.trim();
      const microns = (value.match(/(\d{3})\s*microns?/i) || [])[1] || '';
      const name = value.replace(/\d{3}\s*microns?/i, '').replace(/pose\s+facile/i, '').replace(/\s+/g, ' ').trim();
      const recommended = /pose\s+facile|premium|550/i.test(value);
      const addon = (label.querySelector('.addOn')?.textContent || '').replace(/[()]/g, '').trim();
      item.dataset.dmrThick = recommended ? 'recommended' : 'standard';
      item.closest('.gpo-element')?.setAttribute('data-dmr-thickness', '');
      label.innerHTML = `<span class="dmr-thick-name">${escapeHtml(name)}</span><span class="dmr-thick-microns">${microns ? escapeHtml(microns) + ' microns' : ''}</span><span class="dmr-thick-note">${recommended ? THICKNESS_TEXT.premium : THICKNESS_TEXT.standard}</span><span class="dmr-thick-price">${addon ? escapeHtml(addon) : THICKNESS_TEXT.included}</span>${recommended ? '<span class="dmr-thick-badge">' + THICKNESS_TEXT.badge + '</span>' : ''}`;
    });
  }
  function scheduleOptions() {
    if (!optionsQueued) { optionsQueued = true; requestAnimationFrame(() => { hideRetiredFinish(); enhanceThickness(); }); }
  }
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let queued = false;
  const videos = () => [...document.querySelectorAll('[data-dmr-auto-video]')];
  function source(video) {
    if (!video.getAttribute('src')) video.src = video.dataset.src;
  }
  function state(video) {
    if (!states.has(video)) states.set(video, { paused: false, manual: false });
    return states.get(video);
  }
  function sync() {
    queued = false;
    const list = videos();
    const blocked = document.hidden || !!document.querySelector('dialog[open],.cc-popup.cc-popup--visible,.modal--visible');
    const ordered = list.map(video => {
      const rect = video.getBoundingClientRect();
      return {video, visible: Math.max(0, Math.min(rect.bottom, innerHeight) - Math.max(rect.top, 0)) / Math.min(rect.height || 1, innerHeight)};
    }).sort((a, b) => b.visible - a.visible);
    const best = ordered[0];
    for (const video of list) {
      const s = state(video);
      if (!blocked && best?.video === video && best.visible > .5 && !s.paused && (s.manual || (!reduced.matches && !navigator.connection?.saveData))) {
        source(video);
        video.play().catch(() => {});
      } else video.pause();
    }
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(sync); } }
  function init(root = document) {
    root.querySelectorAll('[data-dmr-product-media]').forEach(module => {
      if (module.dataset.dmrReady) return;
      module.dataset.dmrReady = 'true';
      const video = module.querySelector('video'), button = module.querySelector('[data-dmr-video-toggle]');
      if (!video || !button) return;
      const paint = () => { button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel; button.setAttribute('aria-pressed', String(!video.paused)); };
      video.addEventListener('play', paint);video.addEventListener('pause', paint);
      button.addEventListener('click', () => { const s = state(video); s.paused = !video.paused; s.manual = true; if (s.paused) video.pause(); else schedule(); });
      video.addEventListener('pointerdown', () => { state(video).manual = true; });
      paint();
    });
    root.querySelectorAll('[data-dmr-film-open]').forEach(button => {
      if (button.dataset.dmrReady) return;
      button.dataset.dmrReady = 'true';
      const dialog = document.getElementById(button.dataset.dmrFilmOpen), video = dialog?.querySelector('video');
      if (!dialog || !video) return;
      button.addEventListener('click', () => { videos().forEach(v => v.pause()); source(video); video.muted = true; dialog.showModal(); video.play().catch(() => {}); });
      dialog.querySelector('[data-dmr-film-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {video.pause();schedule();});
      dialog.addEventListener('click', event => {if (event.target !== dialog) return; const r = dialog.getBoundingClientRect();if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();});
    });
    schedule();
    scheduleOptions();
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('video').forEach(video => video.pause()));
  for (const name of ['scroll','resize']) window.addEventListener(name, schedule, {passive:true});
  document.addEventListener('visibilitychange', () => {if(document.hidden)document.querySelectorAll('.dmr-product-film video').forEach(v=>v.pause());schedule();});
  reduced.addEventListener('change',schedule);
  new MutationObserver(schedule).observe(document.documentElement,{subtree:true,attributes:true,attributeFilter:['open']});
  new MutationObserver(scheduleOptions).observe(document.documentElement,{subtree:true,childList:true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
})();
